import { Car } from 'lucide-react';
import { usePublicSettings } from '../../hooks/useApi';
import { t } from '../../i18n';
import { cn } from '../../utils/helpers';

export function BrandMark({ large = false }: { large?: boolean }) {
  const { data } = usePublicSettings();
  const name = data?.company_name || t('Evidencia vozidiel');
  return (
    <div className={cn('flex min-w-0 items-center gap-2.5', large && 'flex-col gap-3')}>
      {data?.logo_light_url ? (
        <img src={data.logo_light_url} alt="" className={cn('shrink-0 object-contain', large ? 'h-14 max-w-[12rem]' : 'h-8 max-w-[5rem]')} />
      ) : (
        <div className={cn('flex shrink-0 items-center justify-center rounded-lg bg-primary-600', large ? 'h-12 w-12' : 'h-8 w-8')}>
          <Car className={cn('text-white', large ? 'h-7 w-7' : 'h-5 w-5')} />
        </div>
      )}
      <span className={cn('truncate font-semibold text-secondary-900', large ? 'text-2xl' : 'text-base')}>{name}</span>
    </div>
  );
}
